import classNames from 'classnames';
import { memo, useCallback } from 'react';
import { FormRadio, ListGroupItem } from 'shards-react';

const ReferenceListItem = (props) => {
	const { reference = '', isChecked = false, isInvalid = false, clickHandler = () => null } = props;
	const stopBubbling = useCallback((e) => e.stopPropagation(), []);
	const classes = classNames('px-2', 'pt-2', 'pb-0', isInvalid && 'text-danger');

	return (
		<ListGroupItem className={classes} onClick={stopBubbling}>
			<FormRadio checked={isChecked} invalid={isInvalid} onClick={clickHandler} children={reference} />
		</ListGroupItem>
	);
};

const areEqual = ({ reference: prevRef }, { reference: nextRef }) => prevRef === nextRef;

export default memo(ReferenceListItem, areEqual);
